// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Gz0","content":"styles_content__JDorL"};